import React, { useState, useEffect } from "react";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate  } from "react-router-dom";
import Home from "../Home";
import Maintenance from "../Maintenance";
import DatePicker from "react-datepicker";
import { subYears } from "date-fns";
import { Select } from "antd";
import { Steps, Button } from "antd";
import { Accordion, Card, Modal, Spinner } from "react-bootstrap";
import {
  fetchClassificationsList,
  fetchCityList,
  getOrganizationInquiryList,
} from "../OrganizationCustomer/actions";
import {
  fetchSuburbList,
  fetchStreetList,
  addOrganizationCustomer,
  addPersonCustomer,
  getCustomerCode,
} from "./actions";
import { getPersonInquiryList } from "../PersonCustomer/actions";
import { getDefaultMaintenanceWindow } from "../TerritoryDefinition/actions";

const { Step } = Steps;

const RESIDENT_DOCTOR_ROLE = "研修医";  // Resident doctor role identifier

/***
@purpose : Functional component
@Parameter : {props}
**/
function NewCustomerRequest(props) {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const [lang] = useTranslation("language");
  const [showMessage, setShowMessage] = useState(false);
  const [organizationRequest, setOrganizationRequest] = useState(false);
  const [personRequest, setPersonRequest] = useState(false);
  const [value, setValue] = useState("");
  const [eventKey, setEventKey] = useState("0");
  const [active, setActive] = useState("esearch-box lg-box");
  const [dropdownList, setDropdownList] = useState([{ speciality: "" }]);
  const [personDropdownList, setPersonDropdownList] = useState([
    { speciality: "" },
  ]);
  const [orgNotice, setOrgNotice] = useState("");
  const [personNotice, setPersonNotice] = useState("");
  const [customerTypeId, setCustomerTypeId] = useState("");
  const [customerTypeName, setCustomerTypeName] = useState("");
  const [kanjiFacilityName, setKanjiFacilityName] = useState("");
  const [kanaFacilityName, setKanaFacilityName] = useState("");
  const [kanjiPharmacistName, setKanjiPharmacistName] = useState("");
  const [kanaPharmacistName, setKanaPharmacistName] = useState("");
  const [kanjiAddressLine, setKanjiAddressLine] = useState("");
  const [kanaAddressLine, setKanaAddressLine] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [prefectureID, setPrefectureID] = useState("");
  const [cityID, setCityID] = useState("");
  const [suburbID, setSuburbID] = useState("");
  const [streetID, setStreetID] = useState("");
  const [prefecture, setPrefecture] = useState("");
  const [city, setCity] = useState("");
  const [suburb, setSuburb] = useState("");
  const [street, setStreet] = useState("");
  const [managementId, setManagementId] = useState("");
  const [managementName, setManagementName] = useState("");
  const [telephone, setTelephone] = useState("");
  const [unifiedCustomerCode, setUnifiedCustomerCode] = useState("");
  const [kanjiCustomerName, setKanjiCustomerName] = useState("");
  const [kanaCustomerName, setKanaCustomerName] = useState("");
  const [kanjiRepresentativeName, setKanjiRepresentativeName] = useState("");
  const [kanaRepresentativeName, setKanaRepresentativeName] = useState("");
  const [representativeCode, setRepresentativeCode] = useState("");
  const [representativeName, setRepresentativeName] = useState("");
  const [numberOfBeds, setNumberOfBeds] = useState("");
  const [openDate, setOpenDate] = useState();
  const [openDateValue, setOpenDateValue] = useState();
  const [graduatedYear, setGraduatedYear] = useState();
  const [graduatedYearValue, setGraduatedYearValue] = useState();
  const [registeredYear, setRegisteredYear] = useState();
  const [registeredYearValue, setRegisteredYearValue] = useState();
  const [birthDate, setBirthDate] = useState();
  const [birthDateValue, setBirthDateValue] = useState();
  // const [birthDateValueUnix, setBirthDateValueUnix] = useState();
  const [genderId, setGenderId] = useState("");
  const [genderName, setGenderName] = useState("");
  const [remarks, setRemarks] = useState("");
  const [speciality, setSpeciality] = useState("");
  const [specialities, setSpecialities] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [universityName, setUniversityName] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [roleId, setRoleId] = useState("");
  const [roleName, setRoleName] = useState("");
  const [universityRoleId, setUniversityRoleId] = useState("");
  const [universityRoleName, setUniversityRoleName] = useState("");
  const [associationId, setAssociationId] = useState("");
  const [associationName, setAssociationName] = useState("");
  const [orgSubmissionId, setOrgSubmissionId] = useState("");
  const [personSubmissionId, setPersonSubmissionId] = useState("");
  const [loading, setLoading] = useState();
  const [orgLoading, setOrgLoading] = useState(false);
  const [personLoading, setPersonLoading] = useState(false);
  const [orgRepresentativeLoading, setOrgRepresentativeLoading] =
    useState(false);
  const [personRepresentativeLoading, setPersonRepresentativeLoading] =
    useState(false);
  const [hospitalStatus, setHospitalStatus] = useState(0);
  const [isUltmarcPharmacist, setIsUltmarcPharmacist] = useState(0);
  const [customerCode, setCustomerCode] = useState();
  const [representativeTotal, setRepresentativeTotal] = useState(0);
  const [orgRepresentativeTotal, setOrgRepresentativeTotal] = useState(0);
  const [orgId, setOrgId] = useState("");
  const [perId, setPerId] = useState("");
  const [noData, setNoData] = useState("");
  const [noRepresentativeData, setNoRepresentativeData] = useState("");
  const [language, setLanguage] = useState("");
  const [personLimit, setPersonLimit] = useState(40);
  const [orgLimit, setOrgLimit] = useState(40);

  const [orgErrors, setOrgErrors] = useState({});
  const [personErrors, setPersonErrors] = useState({});
  const [representativeErrors, setRepresentativeErrors] = useState({});
  const [customerErrors, setCustomerErrors] = useState({});
  const [customerTypeList, setCustomerTypeList] = useState([]);
  const [personCustomerTypeList, setPersonCustomerTypeList] = useState([]);
  const [prefectureList, setPrefectureList] = useState([]);
  const [suburbList, setSuburbList] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [managementList, setManagementList] = useState([]);
  const [streetList, setStreetList] = useState([]);
  const [representativeList, setRepresentativeList] = useState([]);
  const [orgRepresentativeList, setOrgRepresentativeList] = useState([]);
  const [specialityList, setSpecialityList] = useState([]);
  const [universityList, setUniversityList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [genderList, setGenderList] = useState([]);

  const [cityLoading, setCityLoading] = useState(false);
  const [suburbLoading, setSuburbLoading] = useState(false);
  const [streetLoading, setStreetLoading] = useState(false);
  const [maintenance, setMaintenance] = useState(false);
  const [sortCode, setSortCode] = useState("asc");
  const [sortKanjiName, setSortKanjiName] = useState("asc");
  const [sortKanaName, setSortKanaName] = useState("asc");
  const customerList = [
    "101",
    "111",
    "112",
    "132",
    "133",
    "134",
    "135",
    "136",
    "103",
  ];

  const [text, setText] = useState({});
  useEffect(() => {
    document.body.classList.add("sidebar-open");
    const managementBody = sessionStorage.getItem("Management body");
    const prefecture = sessionStorage.getItem("Prefecture");
    const universityList = sessionStorage.getItem("University list");
    const roleList = sessionStorage.getItem("Role");
    const genderList = sessionStorage.getItem("Gender list");
    const departmentList = sessionStorage.getItem("Department");
    const custTypeList = sessionStorage.getItem("Customer type");
    const perCustTypeList = sessionStorage.getItem("Person customer type");
    const speciality = sessionStorage.getItem("Speciality");
    const noticeData = sessionStorage.getItem("Notice");
    const currentLanguage = sessionStorage.getItem("Language");

    setManagementList(JSON.parse(managementBody));
    setPrefectureList(JSON.parse(prefecture));
    setUniversityList(JSON.parse(universityList));
    setRoleList(JSON.parse(roleList));
    setGenderList(JSON.parse(genderList));
    setDepartmentList(JSON.parse(departmentList));
    setCustomerTypeList(JSON.parse(custTypeList));
    setPersonCustomerTypeList(JSON.parse(perCustTypeList));
    setSpecialityList(JSON.parse(speciality));
    setLanguage(currentLanguage);
    const getDefaultMaintenanc = async () => {
      await getDefaultMaintenanceWindow().then((res) => {
        if (res.maintenanceWindowFlag) {
          setMaintenance(true);
        }
      });
    };
    getDefaultMaintenanc();
    if (sessionStorage.getItem("translation")) {
      setText(JSON.parse(sessionStorage.getItem("translation")));
    }
  }, []);

  /*** 
   @purpose : Handle affiliated code
   @Parameter : {item}
   **/
  const [checkState, setcheckState] = useState(false);
  const handleAffiliatedCode = (item) => {
    /*  setRepresentativeCode(item.legacyUnifiedCustomerCode);  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
    setRepresentativeCode(
      item.unifiedCustomerCode
    ); /* SAKAMOTO: AHDD-5861 Ultmarc code change */
    setRepresentativeName(item.facilityName);
    setOrgId(item.orgCustID);
    setcheckState(true);
  };

  const [finalText, setfinalText] = useState("");
  const [finalText2, setfinalText2] = useState("");
  useEffect(() => {
    setOrgNotice(
      props.language === "en"
        ? sessionStorage.getItem("en_org_notice")
        : sessionStorage.getItem("jp_org_notice")
    );
    setPersonNotice(
      props.language === "en"
        ? sessionStorage.getItem("en_person_notice")
        : sessionStorage.getItem("jp_person_notice")
    );
    const searchText = "notice_dcr";
    const searchText2 = "commonmessage";
    const filteredTexts = {};
    const filteredTexts2 = {};
    for (const key in text) {
      if (key.includes(searchText)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts[langKey] = value;
        }
      }
    }
    for (const key in text) {
      if (key.includes(searchText2)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts2[langKey] = value;
        }
      }
    }
    if (filteredTexts[props.language]) {
        setfinalText(filteredTexts[props.language]);
    }
    if (filteredTexts2[props.language]) {
      setfinalText2(filteredTexts2[props.language]);
    }

  }, [props.language, text, sessionStorage.getItem("Language")]);

  const [ultraMacFlagValue, setUltraMacFlagValue] = useState(false);
  useEffect(() => {
    if (
      customerCode === "120" &&
      representativeCode.substring(0, 2) === "00" &&
      checkState
    ) {
      setUltraMacFlagValue(true);
    } else {
      setUltraMacFlagValue(false);
    }
  }, [
    customerCode,
    unifiedCustomerCode,
    checkState,
    representativeCode,
    representativeName,
    orgId,
  ]);

  /*** 
  @purpose : Handle select
  @Parameter : {}
  **/
  const handleSelect = () => {
    setActive("esearch-box lg-box lg-left active");
  };

  /*** 
  @purpose : Handle close
  @Parameter : {}
  **/
  const handleClose = () => {
    setActive("esearch-box lg-box");
  };

  const handleCloseMessage = () => setShowMessage(false);

  /*** 
  @purpose : Handle speciality
  @Parameter : {value}
  **/
  const handleSpeciality = (value) => {
    if (value.length <= 60) {
      setSpecialities(value);
    } else {
      setSpecialities(specialities);
    }
  };

  /*** 
  @purpose : Handle speciality
  @Parameter : {value}
  **/
  const handlePersonSpeciality = (value) => {
    if (value.length <= 5) {
      setSpecialities(value);
    } else {
      setSpecialities(specialities);
    }
  };

  /*** 
  @purpose : Handle management change
  @Parameter : {value}
  **/
  const handleManagementChange = (value) => {
    if (value) {
      setManagementId(value.value);
      setManagementName(value.label);
    } else {
      setManagementId("");
      setManagementName("");
    }
  };

  const calculateInitialDate = (selectedDate) => {
    return selectedDate ? selectedDate : subYears(new Date(), 26);
  };

  /*** 
  @purpose : Handle gender change
  @Parameter : {value}
  **/
  const handleGenderChange = async (value) => {
    if (value) {
      setGenderId(value.value);
      setGenderName(value.label);
    } else {
      setGenderId("");
      setGenderName("");
    }
  };

  /*** 
  @purpose : Handle state change
  @Parameter : {value}
  **/
  const handleStateChange = async (value) => {
    setPrefectureID("");
    setPrefecture("");
    setCity("");
    setCityID("");
    setSuburb("");
    setSuburbID("");
    setStreetID("");
    setStreet("");
    if (value) {
      setCityLoading(true);
      let id = value.value;
      setPrefecture(value.label);
      setPrefectureID(id);
      await fetchCityList(id).then((res) => {
        setCityLoading(false);
        let newCity = [];
        for (let index = 0; index < res.length; index++) {
          const cityOne = res[index];
          newCity.push({ value: cityOne.cityID, label: cityOne.cityName });
        }
        setCityData(newCity);
      });
    } else {
      setCityLoading(false);
      setPrefectureID("");
      setPrefecture("");
      setCity("");
      setCityID("");
      setSuburb("");
      setSuburbID("");
      setStreetID("");
      setStreet("");
      setCityData([]);
    }
  };

  /*** 
  @purpose : Handle city change
  @Parameter : {value}
  **/
  const handleCityChange = async (value) => {
    setSuburbLoading(true);
    setSuburbID("");
    setSuburb("");
    setStreetID("");
    setStreet("");
    if (value) {
      setCityID(value.value);
      setCity(value.label);
      await fetchSuburbList({
        stateId: prefectureID,
        cityId: value.value,
      }).then((res) => {
        setSuburbLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const suburb = res[index];
          list.push({ value: suburb.suburbID, label: suburb.suburbName });
        }
        setSuburbList(list);
      });
    } else {
      setSuburbLoading(false);
      setCity("");
      setCityID("");
      setSuburbID("");
      setSuburb("");
      setStreetID("");
      setStreet("");
      setSuburbList([]);
    }
  };

  /*** 
  @purpose : Handle suburb change
  @Parameter : {value}
  **/
  const handleSuburbChange = async (value) => {
    setStreetLoading(true);
    setStreetID("");
    setStreet("");
    if (value) {
      setSuburbID(value.value);
      setSuburb(value.label);
      await fetchStreetList({
        stateId: prefectureID,
        cityId: cityID,
        suburbId: value.value,
      }).then((res) => {
        setStreetLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const street = res[index];
          list.push({ value: street.streetID, label: street.streetName });
        }
        setStreetList(list);
      });
    } else {
      setStreetLoading(false);
      setSuburbID("");
      setSuburb("");
      setStreetID("");
      setStreet("");
      setStreetList([]);
    }
  };

  /*** 
  @purpose : Handle street change
  @Parameter : {value}
  **/
  const handleStreetChange = async (value) => {
    if (value) {
      setStreetID(value.value);
      setStreet(value.label);
    } else {
      setStreetID("");
      setStreet("");
    }
  };

  /*** 
  @purpose : Handle customer type
  @Parameter : {value}
  **/
  const handleCustomerType = async (value) => {
    if (value) {
      setCustomerTypeId(value.value);
      setCustomerTypeName(value.label);
      let body = {
        customer_type_id: value.value,
      };
      await getCustomerCode(body).then((res) => {
        setCustomerCode(res && res.data);
      });
    } else {
      setCustomerTypeId("");
      setCustomerTypeName("");
    }
  };

  /*** 
  @purpose : Handle person customer type
  @Parameter : {value}
  **/
  const handlePersonCustomerType = async (value) => {
    if (value) {
      setCustomerTypeId(value.value);
      setCustomerTypeName(value.label);
      let body = {
        customer_type_id: value.value,
      };
      await getCustomerCode(body).then((res) => {
        setCustomerCode(res && res.data);
      });
    } else {
      setCustomerTypeId("");
      setCustomerTypeName("");
    }
  };

  /*** 
  @purpose : Handle university
  @Parameter : {value}
  **/
  const handleUniversity = (value) => {
    if (value) {
      setUniversityId(value.value);
      setUniversityName(value.label);
    } else {
      setUniversityId("");
      setUniversityName("");
    }
  };

  /*** 
  @purpose : Handle department
  @Parameter : {value}
  **/
  const handleDepartment = (value) => {
    if (value) {
      setDepartmentId(value.value);
      setDepartmentName(value.label);
    } else {
      setDepartmentId("");
      setDepartmentName("");
    }
  };

  /*** 
  @purpose : Handle role
  @Parameter : {value}
  **/
  const handleRole = (value) => {
    if (value) {
      setRoleId(value.value);
      setRoleName(value.label);
    } else {
      setRoleId("");
      setRoleName("");
    }
  };

  /*** 
  @purpose : Handle university role
  @Parameter : {value}
  **/
  const handleUniversityRole = (value) => {
    if (value) {
      setUniversityRoleId(value.value);
      setUniversityRoleName(value.label);
    } else {
      setUniversityRoleId("");
      setUniversityRoleName("");
    }
  };

  /*** 
  @purpose : Handle association
  @Parameter : {value}
  **/
  const handleAssociation = (value) => {
    if (value) {
      setAssociationId(value.value);
      setAssociationName(value.label);
    } else {
      setAssociationId("");
      setAssociationName("");
    }
  };

  /*** 
  @purpose : Handle hospital status
  @Parameter : {e}
  **/
  const handleHospitalStatus = (e) => {
    let status = e.target.checked;
    setHospitalStatus(status ? 1 : 0);
  };

  /*** 
  @purpose : Handle hospital status
  @Parameter : {e}
  **/
  const handleUltmarcPharmacistFlag = (e) => {
    let status = e.target.checked;
    setIsUltmarcPharmacist(status === true ? 1 : 0);
  };
  /*** 
  @purpose : Handle open date
  @Parameter : {date}
  **/
  const handleOpenDate = (date) => {
    if (date) {
      setOpenDateValue(date);
      var date = new Date(date),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      setOpenDate([date.getFullYear(), mnth, day].join("/"));
    } else {
      setOpenDateValue();
      setOpenDate();
    }
  };

  /*** 
  @purpose : Handle graduated year
  @Parameter : {date}
  **/
  const handleGraduatedYear = (date) => {
    if (date) {
      setGraduatedYearValue(date);
      var date = new Date(date);
      setGraduatedYear(date.getFullYear().toString());
    } else {
      setGraduatedYear();
      setGraduatedYearValue();
    }
  };

  /*** 
  @purpose : Handle submitted at
  @Parameter : {date}
  **/
  const handleBirthDate = (date) => {
    if (date) {
      setBirthDateValue(date);
      // setBirthDateValueUnix(parseInt((new Date(date).getTime() / 1000).toFixed(0)))
      var fullDate = new Date(date),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      var dt = [fullDate.getFullYear(), mnth, day].join("-");
      setBirthDate(dt);
    } else {
      setBirthDateValue();
      setBirthDate();
    }
  };

  /*** 
  @purpose : Handle registered year
  @Parameter : {date}
  **/
  const handleRegisteredYear = (date) => {
    if (date) {
      setRegisteredYearValue(date);
      var date = new Date(date);
      setRegisteredYear(date.getFullYear().toString());
    } else {
      setRegisteredYear();
      setRegisteredYearValue();
    }
  };

  /*** 
  @purpose : Handle representative code
  @Parameter : {item}
  **/
  const handleRepresentativeCode = (item) => {
    /*  setRepresentativeCode(item.legacyUnifiedCustomerCode);  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
    setRepresentativeCode(
      item.unifiedCustomerCode
    ); /* SAKAMOTO: AHDD-5861 Ultmarc code change */
    setPerId(item.perCustID);
  };

  /*** 
  @purpose : Go to next step
  @Parameter : {}
  **/
  const next = () => {
    if (organizationRequest) {
      if (validateOrgForm()) {
        setCurrent(current + 1);
      }
    } else if (personRequest) {
      if (validatePersonForm()) {
        setCurrent(current + 1);
      }
    }
  };

  /*** 
  @purpose : Go to previous step
  @Parameter : {}
  **/
  const prev = () => {
    setCurrent(current - 1);
  };

  /*** 
  @purpose : Change route
  @Parameter : {e, page}
  **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  /*** 
  @purpose : Handle request
  @Parameter : {e}
  **/
  const handleRequest = (e) => {
    setValue(e.target.value);
  };

  /*** 
  @purpose : Handle submit
  @Parameter : {}
  **/
  const handleSubmit = () => {
    setEventKey(eventKey === "0" ? "1" : "0");
    if (value === "Organization Customer" || value === "") {
      setPersonRequest(false);
      setOrganizationRequest(true);
    } else if (value === "Person Customer") {
      setOrganizationRequest(false);
      setPersonRequest(true);
    }
  };

  /*** 
  @purpose : Handle sorting
  @Parameter : {obj}
  **/
  const handleSortingData = (obj) => {
    /*  obj.column === "legacyUnifiedCustomerCode" && setSortCode(obj.sortOrder); /* SAKAMOTO: AHDD-5861 Ultmarc code change */
    obj.column === "unifiedCustomerCode" &&
      setSortCode(obj.sortOrder); /* SAKAMOTO: AHDD-5861 Ultmarc code change */
    obj.column === "customerNameLocal" && setSortKanjiName(obj.sortOrder);
    obj.column === "customerNameLocalKana" && setSortKanaName(obj.sortOrder);
    let list = compareBySortedData(obj);
    setRepresentativeList(list);
  };

  /*** 
  @purpose : Compare sorting
  @Parameter : {obj}
  **/
  const compareBySortedData = (obj) => {
    const sorted = representativeList.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };

  /*** 
  @purpose : Hnadle person sorting data
  @Parameter : {obj}
  **/
  const handlePersonSortingData = (obj) => {
    obj.column === "unifiedCustomerCode" && setSortCode(obj.sortOrder);
    obj.column === "facilityName" && setSortKanjiName(obj.sortOrder);
    obj.column === "customerTypeName" && setSortKanaName(obj.sortOrder);
    let list = compareByPersonSortedData(obj);
    setRepresentativeList(list);
  };

  /*** 
  @purpose : Compare person sorted data
  @Parameter : {obj}
  **/
  const compareByPersonSortedData = (obj) => {
    const sorted = representativeList.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };

  /*** 
  @purpose : Validate get representative code form
  @Parameter : {}
  **/
  const validateRepresentativeForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<.|\n*?>]/);
    let regex = new RegExp(
      /[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[a-zA-Z0-9]+|[ａ-ｚＡ-Ｚ０-９]+[々〆〤]+/
    );
    let kanaRegex = new RegExp(/^[ｦ-ﾟ -~]+$/);
    let errors = {
      kanjiCustomerName: "",
      kanaCustomerName: "",
    };

    // if (kanjiCustomerName && !regex.test(kanjiCustomerName)) errors.kanjiCustomerName = "errorMessages.VALID_KANJI_CUSTOMER_NAME";
    if (kanjiCustomerName && pattern.test(kanjiCustomerName))
      errors.kanjiCustomerName = "errorMessages.VALID_KANJI_CUSTOMER_NAME";
    else errors.kanjiCustomerName = "";

    if (kanaCustomerName && kanaRegex.test(kanaCustomerName) === false)
      errors.kanaCustomerName = "errorMessages.VALID_KANA_CUSTOMER_NAME";
    else errors.kanaCustomerName = "";

    if (errors.kanjiCustomerName !== "" || errors.kanaCustomerName !== "") {
      isFormValid = false;
    } else {
      isFormValid = true;
    }
    setRepresentativeErrors(errors);

    return isFormValid;
  };

  /*** 
  @purpose : Validate get representative code form
  @Parameter : {}
  **/
  const validateCustomerCodeForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<.|\n*?>]/);
    let kanaRegex = new RegExp(/^[ｦ-ﾟ -~]+$/);
    let regex = new RegExp(
      /[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[a-zA-Z0-9]+|[ａ-ｚＡ-Ｚ０-９]+[々〆〤]+/
    );
    let errors = {
      kanjiCustomerName: "",
      kanaCustomerName: "",
    };

    // if (kanjiCustomerName && !regex.test(kanjiCustomerName)) errors.kanjiCustomerName = "errorMessages.VALID_KANJI_CUSTOMER_NAME";
    if (kanjiCustomerName && pattern.test(kanjiCustomerName) === true)
      errors.kanjiCustomerName = "errorMessages.VALID_KANJI_CUSTOMER_NAME";
    else errors.kanjiCustomerName = "";

    if (kanaCustomerName && kanaRegex.test(kanaCustomerName) === false)
      errors.kanaCustomerName = "errorMessages.VALID_KANA_CUSTOMER_NAME";
    else errors.kanaCustomerName = "";

    if (errors.kanjiCustomerName !== "" || errors.kanaCustomerName !== "") {
      isFormValid = false;
    } else {
      isFormValid = true;
    }
    setCustomerErrors(errors);

    return isFormValid;
  };

  /*** 
  @purpose : Get representative list
  @Parameter : {}
  **/
  const getRepresentativeList = async () => {
    if (validateRepresentativeForm()) {
      setOrgRepresentativeLoading(true);
      setLoading(true);
      let body = {
        unifiedCustomerCode: unifiedCustomerCode,
        personNameKanji: kanjiCustomerName,
        personNameKana: kanaCustomerName,
        limit: 0,
        totalrecords: 0,
      };
      await getPersonInquiryList(body).then((response) => {
        if (response.maintenanceWindowFlag) {
          setMaintenance(true);
        } else {
          if (response.success === true && response.data.length > 0) {
            setOrgRepresentativeLoading(false);
            setOrgRepresentativeList(response.data);
            setLoading(false);
            setNoData(false);
            setNoRepresentativeData(false);
            setOrgRepresentativeTotal(response.data[0].total);
          }
          if (
            (response.success === true && response.data.length === 0) ||
            response.success === false
          ) {
            setOrgRepresentativeLoading(false);
            setLoading(false);
            setNoRepresentativeData(true);
            setOrgRepresentativeList([]);
            setOrgRepresentativeTotal();
          }
        }
      });
    }
  };

  /*** 
  @purpose : Handle org lazy loading
  @Parameter : {}
  **/
  const handleOrgContainerOnBottom = async () => {
    let body = {
      unifiedCustomerCode: unifiedCustomerCode,
      personNameKanji: kanjiCustomerName,
      personNameKana: kanaCustomerName,
      limit: orgRepresentativeList.length,
      totalRecords: orgRepresentativeTotal,
    };
    if (
      orgRepresentativeList.length <= orgRepresentativeTotal &&
      orgRepresentativeTotal >= 30
    ) {
      await getPersonInquiryList(body).then((response) => {
        let list = [];
        list = orgRepresentativeList.concat(response.data);
        setOrgRepresentativeList(list);
      });
      setOrgLimit(orgLimit + 10);
    }
  };

  /*** 
  @purpose : Handle person lazy loading
  @Parameter : {}
  **/
  const handlePersonContainerOnBottom = async () => {
    let body = {
      unifiedCustomerCode: unifiedCustomerCode,
      customerNameLocal: kanjiCustomerName,
      personNameKana: kanaCustomerName,
      limit: representativeList.length,
      totalRecords: representativeTotal,
    };
    if (
      representativeList.length <= representativeTotal &&
      representativeTotal >= 30
    ) {
      await getOrganizationInquiryList(body).then((response) => {
        let list = [];

        list = representativeList.concat(response.data);
        setRepresentativeList(list);
      });
      setPersonLimit(personLimit + 10);
    }
  };

  const orgRef = useBottomScrollListener(handleOrgContainerOnBottom);
  const personRef = useBottomScrollListener(handlePersonContainerOnBottom);

  /*** 
  @purpose : Get org representative list
  @Parameter : {}
  **/
  const getOrgRepresentativeList = async () => {
    if (validateCustomerCodeForm()) {
      setPersonRepresentativeLoading(true);
      setLoading(true);
      let body = {
        unifiedCustomerCode: unifiedCustomerCode,
        customerNameLocal: kanjiCustomerName,
        personNameKana: kanaCustomerName,
        limit: 0,
        totalrecords: 0,
        isCustomerDCRFilter: true
      };
      await getOrganizationInquiryList(body).then((response) => {
        if (response.maintenanceWindowFlag) {
          setMaintenance(true);
        } else {
          setPersonRepresentativeLoading(false);
          if (response.success === true && response.data.length > 0) {
            setRepresentativeList(response.data);
            setLoading(false);
            setNoData(false);
            setRepresentativeTotal(response.data[0].total);
          }
          if (
            (response.success === true && response.data.length === 0) ||
            response.success === false
          ) {
            setPersonRepresentativeLoading(false);
            setLoading(false);
            setNoData(true);
            setRepresentativeList([]);
          }
        }
      });
    }
  };

  /*** 
  @purpose : Validate new org customer form
  @Parameter : {}
  **/
  const validateOrgForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<.|\n*?>]/);
    let kanaRegex = new RegExp(/^[ｦ-ﾟ -~]+$/);
    let postalCodePattern = new RegExp(/^[0-9]{3}-[0-9]{4}$/);
    let numbers = new RegExp(/^[0-9-]+$/);
    let errors = {
      customerType: "",
      kanjiFacilityName: "",
      kanaFacilityName: "",
      postalCode: "",
      prefecture: "",
      city: "",
      suburb: "",
      street: "",
      kanjiAddressLine: "",
      kanaAddressLine: "",
      telephone: "",
      kanjiRepresentativeName: "",
      kanaRepresentativeName: "",
      kanjiPharmacistName: "",
      kanaPharmacistName: "",
      numberOfBeds: "",
      specialities: "",
      remarks: "",
    };

    if (customerTypeId === "")
      errors.customerType = "errorMessages.PROVIDE_CUSTOMER_TYPE";

    if (kanjiFacilityName && pattern.test(kanjiFacilityName) === true)
      errors.kanjiFacilityName = "errorMessages.VALID_KANJI_FACILITY_NAME";
    else if (kanjiFacilityName === "")
      errors.kanjiFacilityName = "errorMessages.PROVIDE_KANJI_FACILITY_NAME";
    else errors.kanjiFacilityName = "";

    if (kanaFacilityName && pattern.test(kanaFacilityName) === true)
      errors.kanaFacilityName = "errorMessages.VALID_KANA_FACILITY_NAME";
    else if (kanaFacilityName && kanaRegex.test(kanaFacilityName) === false)
      errors.kanaFacilityName = "errorMessages.VALID_KANA_FACILITY_NAME";
    else errors.kanaFacilityName = "";

    if (kanjiAddressLine && pattern.test(kanjiAddressLine))
      errors.kanjiAddressLine = "errorMessages.VALID_KANJI_ADDRESS";
    else if (kanjiAddressLine === "")
      errors.kanjiAddressLine = "errorMessages.PROVIDE_KANJI_ADDRESS";

    if (kanaAddressLine && pattern.test(kanaAddressLine))
      errors.kanaAddressLine = "errorMessages.VALID_KANA_ADDRESS";
    else if (kanaAddressLine && kanaRegex.test(kanaAddressLine) === false)
      errors.kanaAddressLine = "errorMessages.VALID_KANA_ADDRESS";

    if (telephone && numbers.test(telephone) === false)
      errors.telephone = "errorMessages.VALID_NUMBER";
    else if (telephone === "")
      errors.telephone = "errorMessages.PROVIDE_NUMBER";
    else errors.telephone = "";

    if (postalCode && postalCodePattern.test(postalCode) === false)
      errors.postalCode = "errorMessages.VALID_POSTAL_CODE";
    else errors.postalCode = "";

    if (prefectureID === "")
      errors.prefecture = "errorMessages.PROVIDE_PREFECTURE";

    if (cityID === "") errors.city = "errorMessages.PROVIDE_CITY";

    if (suburbID === "") errors.suburb = "errorMessages.PROVIDE_SUBURB";

    if (streetID === "") errors.street = "errorMessages.PROVIDE_STREET";

    if (
      kanjiRepresentativeName &&
      pattern.test(kanjiRepresentativeName) === true
    )
      errors.kanjiRepresentativeName =
        "errorMessages.VALID_KANJI_REPRESENTATIVE";
    else errors.kanjiRepresentativeName = "";

    if (
      kanaRepresentativeName &&
      kanaRegex.test(kanaRepresentativeName) === false
    )
      errors.kanaRepresentativeName = "errorMessages.VALID_KANA_REPRESENTATIVE";
    else errors.kanaRepresentativeName = "";

    if (kanjiPharmacistName && pattern.test(kanjiPharmacistName) === true)
      errors.kanjiPharmacistName = "errorMessages.VALID_KANJI_PHARMACIST";
    else errors.kanjiPharmacistName = "";

    if (kanaPharmacistName && kanaRegex.test(kanaPharmacistName) === false)
      errors.kanaPharmacistName = "errorMessages.VALID_KANA_PHARMACIST";
    else errors.kanaPharmacistName = "";

    if (numberOfBeds && numbers.test(numberOfBeds) === false)
      errors.numberOfBeds = "errorMessages.PROVIDE_NUMBER_OF_BEDS";
    else if (customerCode === "200" && numberOfBeds === "")
      errors.numberOfBeds = "errorMessages.PROVIDE_NUMBER_OF_BEDS";
    else errors.numberOfBeds = "";

    if (specialities.length === 0)
      errors.specialities = "errorMessages.PROVIDE_SPECIALITY";

    if (remarks && pattern.test(remarks))
      errors.remarks = "errorMessages.VALID_REMARKS";

    if (customerCode === "200") {
      if (
        errors.customerType !== "" ||
        errors.kanjiFacilityName !== "" ||
        errors.kanaFacilityName !== "" ||
        errors.postalCode !== "" ||
        errors.prefecture !== "" ||
        errors.city !== "" ||
        errors.suburb !== "" ||
        errors.street !== "" ||
        errors.kanjiAddressLine !== "" ||
        errors.kanaAddressLine !== "" ||
        errors.telephone !== "" ||
        errors.postalCode !== "" ||
        errors.kanjiRepresentativeName !== "" ||
        errors.kanaRepresentativeName !== "" ||
        errors.specialities ||
        errors.numberOfBeds !== "" ||
        errors.remarks !== ""
      ) {
        isFormValid = false;
      } else {
        isFormValid = true;
      }
    } else {
      if (
        errors.customerType !== "" ||
        errors.kanjiFacilityName !== "" ||
        errors.kanaFacilityName !== "" ||
        errors.postalCode !== "" ||
        errors.prefecture !== "" ||
        errors.city !== "" ||
        errors.suburb !== "" ||
        errors.street !== "" ||
        errors.kanjiAddressLine !== "" ||
        errors.kanaAddressLine !== "" ||
        errors.telephone !== "" ||
        errors.postalCode !== "" ||
        errors.kanjiRepresentativeName !== "" ||
        errors.kanaRepresentativeName !== "" ||
        errors.remarks !== ""
      ) {
        isFormValid = false;
      } else {
        isFormValid = true;
      }
    }

    setOrgErrors(errors);

    return isFormValid;
  };

  /*** 
  @purpose : Add org customer
  @Parameter : {}
  **/
  const addOrgCustomer = async () => {
    const WWID = sessionStorage.getItem("WWID");
    setOrgLoading(true);
    let list = [];
    specialities.map((sp) => list.push(sp.value.toString()));
    let body = {
      customer_type: customerTypeId,
      perCustID: perId,
      facility_name_kanji: kanjiFacilityName,
      facility_name_kana: kanaFacilityName,
      management_body_type: managementId,
      postal_code: postalCode,
      prefecture: prefectureID,
      city: cityID,
      street: streetID,
      suburb: suburbID,
      address_line_kanji: kanjiAddressLine,
      address_line_kana: kanaAddressLine,
      tel: telephone,
      representative_person_code: representativeCode,
      representative_person_name_kanji: kanjiRepresentativeName,
      representative_person_name_kana: kanaRepresentativeName,
      kanji_pharmacist_name: kanjiPharmacistName,
      kana_pharmacist_name: kanaPharmacistName,
      number_of_beds: numberOfBeds,
      planned_open_date: openDate,
      specialities: list,
      remarks: remarks,
      ultmarcRecordID: "",
    };
    await addOrganizationCustomer(body).then((response) => {
      if (response.success === true) {
        setOrgLoading(false);
        setOrgSubmissionId(response.id);
        setCurrent(current + 1);
      } else if (response.success === false) {
        setOrgLoading(false);
        setShowMessage(true);
      }
    });
  };

  /*** 
  @purpose : Validate new person customer form
  @Parameter : {}
  **/
  const validatePersonForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<.|\n*?>]/);
    let kanaRegex = new RegExp(/^[ｦ-ﾟ -~]+$/);
    let errors = {
      customerType: "",
      kanjiFacilityName: "",
      kanaFacilityName: "",
      department: "",
      specialities: "",
      representativeCode: "",
      remarks: "",
      graduatedUniversity: "",
      graduatedYear: "",
      registeredYear: "",
      birthDate: "",
    };

    if (customerTypeId === "")
      errors.customerType = "errorMessages.PROVIDE_CUSTOMER_TYPE";

    if (kanjiFacilityName && pattern.test(kanjiFacilityName) === true)
      errors.kanjiFacilityName = "errorMessages.VALID_KANJI_NAME";
    else if (kanjiFacilityName === "")
      errors.kanjiFacilityName = "errorMessages.PROVIDE_KANJI_NAME";
    else errors.kanjiFacilityName = "";

    if (kanaFacilityName && kanaRegex.test(kanaFacilityName) === false)
      errors.kanaFacilityName = "errorMessages.VALID_KANA_NAME";
    else errors.kanaFacilityName = "";

    // Check if role or university role is "研修医" (resident doctor)
    const isResidentDoctor = roleName === RESIDENT_DOCTOR_ROLE || universityRoleName === RESIDENT_DOCTOR_ROLE;

    // Only require specialities for doctors who are not residents
    if (customerCode === "100" && !isResidentDoctor) {
      if (specialities.length === 0) {
        errors.specialities = "errorMessages.PROVIDE_SPECIALITY";
      } else {
        errors.specialities = "";  // Clear error when specialities provided
      }
    } else {
      errors.specialities = "";  // Clear error for resident doctors or non-doctors
    }

    if (representativeCode === "")
      errors.representativeCode =
        "errorMessages.PROVIDE_AFFILIATED_CUSTOMER_CODE";

    if (departmentId === "")
      errors.department = "errorMessages.PROVIDE_AFFILIATED_CUSTOMER_CODE";

    if (remarks && pattern.test(remarks))
      errors.remarks = "errorMessages.VALID_REMARKS";

    // For doctor or hospital pharmacist, show error only if all four fields are empty
    if (customerCode === "100" || (customerCode === "120" && ultraMacFlagValue === true)) {
      const allFieldsEmpty = !universityName && !graduatedYear && !registeredYear && !birthDate;
      
      if (allFieldsEmpty) {
        errors.graduatedUniversity = "errorMessages.DOCTOR_PHARMACIST_REQUIRED_FIELD";
        errors.graduatedYear = "errorMessages.DOCTOR_PHARMACIST_REQUIRED_FIELD";
        errors.registeredYear = "errorMessages.DOCTOR_PHARMACIST_REQUIRED_FIELD";
        errors.birthDate = "errorMessages.DOCTOR_PHARMACIST_REQUIRED_FIELD";
      }
    }

    if (customerCode === "100") {
      if (
        errors.customerType !== "" ||
        errors.kanjiFacilityName !== "" ||
        errors.kanaFacilityName !== "" ||
        errors.specialities !== "" ||
        errors.representativeCode !== "" ||
        errors.remarks !== "" ||
        errors.graduatedUniversity !== "" ||
        errors.graduatedYear !== "" ||
        errors.registeredYear !== "" ||
        errors.birthDate !== ""
      ) {
        isFormValid = false;
      } else {
        isFormValid = true;
      }
    } else if (customerCode === "120" && ultraMacFlagValue === true) {
      if (
        errors.customerType !== "" ||
        errors.kanjiFacilityName !== "" ||
        errors.kanaFacilityName !== "" ||
        errors.representativeCode !== "" ||
        errors.remarks !== "" ||
        errors.graduatedUniversity !== "" ||
        errors.graduatedYear !== "" ||
        errors.registeredYear !== "" ||
        errors.birthDate !== ""
      ) {
        isFormValid = false;
      } else {
        isFormValid = true;
      }
    } else {
      if (
        errors.customerType !== "" ||
        errors.kanjiFacilityName !== "" ||
        errors.kanaFacilityName !== "" ||
        errors.representativeCode !== "" ||
        errors.remarks !== ""
      ) {
        isFormValid = false;
      } else {
        isFormValid = true;
      }
    }
    setPersonErrors(errors);
    return isFormValid;
  };

  /*** 
  @purpose : Add person customer
  @Parameter : {}
  **/
  const addPerCustomer = async () => {
    setPersonLoading(true);
    let list = [];
    specialities.map((sp) => list.push(sp.value.toString()));
    let body = {
      customer_type: customerTypeId,
      customer_name_kanji: kanjiFacilityName,
      customer_name_kana: kanaFacilityName,
      gender: genderId,
      birth_date_japanese_era: birthDate,
      birth_place: prefectureID,
      doctor_pharmacist_association: associationId,
      graduated_university: universityId,
      graduated_year: graduatedYear,
      registered_year: registeredYear,
      specialities: list,
      affiliated_organization_customer: orgId,
      affiliated_department: departmentId,
      role: roleId,
      university_role: universityRoleId,
      hospital_owner: hospitalStatus,
      remarks: remarks,
      ultmarc_pharmacist_flag:
        customerCode === "120" && representativeCode.substring(0, 2) === "00"
          ? 1
          : 0,
    };

    await addPersonCustomer(body).then((response) => {
      if (response.success === true) {
        setPersonLoading(false);
        setPersonSubmissionId(response.id);
        setCurrent(current + 1);
      } else if (response.success === false) {
        setPersonLoading(false);
        setShowMessage(true);
      }
    });
  };

  /*** 
  @purpose : Go to home
  @Parameter : {}
  **/
  const goToHome = () => {
    setOrganizationRequest(false);
    setPersonRequest(false);
    setEventKey("0");
  };

  const organizationSteps = [
    {
      title: `${lang("organizationDetails.custNewChangeRequest")}`,
      content: (
        <React.Fragment>
          <div className="warning-box card">
            <div className="card-body">
              {/* <div className="warning-icon">
                <img src="images/warning.svg" alt="warning" />
              </div> */}
              {/* <h4>{lang("organizationDetails.noticeLabel")}</h4> */}
              <p
                className="notice"
                dangerouslySetInnerHTML={{ __html: orgNotice }}
              />
            </div>
          </div>
          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.custNewChangeRequest")}</h4>
            </div>
            <div className="card-body">
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.submissionID")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input type="text" className="form-control" readOnly />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.unifiedCustomerCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value=""
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.customerType")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={customerTypeList}
                      onChange={handleCustomerType}
                      allowClear={true}
                      placeholder={
                        customerTypeName
                          ? customerTypeName
                          : `${lang("organizationDetails.customerType")}`
                      }
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                    {orgErrors.customerType && (
                      <p className="error-text">
                        {lang(`${orgErrors.customerType}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.kanjiFacilityName")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength="100"
                      onChange={(e) => setKanjiFacilityName(e.target.value)}
                      value={kanjiFacilityName}
                    />
                    {orgErrors.kanjiFacilityName && (
                      <p className="error-text">
                        {lang(`${orgErrors.kanjiFacilityName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.kanaFacilityName")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength="100"
                      onChange={(e) => setKanaFacilityName(e.target.value)}
                      value={kanaFacilityName}
                    />
                    {orgErrors.kanaFacilityName && (
                      <p className="error-text">
                        {lang(`${orgErrors.kanaFacilityName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.managementBody")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      placeholder={
                        managementName
                          ? managementName
                          : `${lang("organizationDetails.managementBody")}`
                      }
                      onChange={handleManagementChange}
                      allowClear={true}
                      options={managementList}
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.postalCode")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      onChange={(e) => setPostalCode(e.target.value)}
                      maxLength="8"
                      value={postalCode}
                    />
                    {orgErrors.postalCode && (
                      <p className="error-text">
                        {lang(`${orgErrors.postalCode}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("parentChildFacilityMaintenance.prefecture")}
                  </label>
                  <span className="danger">*</span>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={prefectureList}
                      placeholder={
                        prefecture
                          ? prefecture
                          : `${lang(
                              "parentChildFacilityMaintenance.prefecture"
                            )}`
                      }
                      value={{ value: prefectureID, label: prefecture }}
                      allowClear={prefectureID ? true : false}
                      onChange={handleStateChange}
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                    {orgErrors.prefecture && (
                      <p className="error-text">
                        {lang(`${orgErrors.prefecture}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("parentChildFacilityMaintenance.city")}</label>
                  <span className="danger">*</span>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={cityData}
                      loading={cityLoading}
                      placeholder={
                        city
                          ? city
                          : `${lang("parentChildFacilityMaintenance.city")}`
                      }
                      value={{ value: cityID, label: city }}
                      allowClear={cityID ? true : false}
                      onChange={handleCityChange}
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                    {orgErrors.city && (
                      <p className="error-text">{lang(`${orgErrors.city}`)}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.suburb")}</label>
                  <span className="danger">*</span>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={suburbList}
                      placeholder={
                        suburb
                          ? suburb
                          : `${lang("organizationDetails.suburb")}`
                      }
                      loading={suburbLoading}
                      value={{ value: suburbID, label: suburb }}
                      allowClear={suburbID ? true : false}
                      onChange={handleSuburbChange}
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                    {orgErrors.suburb && (
                      <p className="error-text">
                        {lang(`${orgErrors.suburb}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.street")}</label>
                  <span className="danger">*</span>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={streetList}
                      placeholder={
                        street
                          ? street
                          : `${lang("organizationDetails.street")}`
                      }
                      value={{ value: streetID, label: street }}
                      allowClear={streetID ? true : false}
                      loading={streetLoading}
                      onChange={handleStreetChange}
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                    {orgErrors.street && (
                      <p className="error-text">
                        {lang(`${orgErrors.street}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.kanjiAddressLine")}</label>
                  <span className="danger">*</span>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength="100"
                      onChange={(e) => setKanjiAddressLine(e.target.value)}
                      value={kanjiAddressLine}
                    />
                    {orgErrors.kanjiAddressLine && (
                      <p className="error-text">
                        {lang(`${orgErrors.kanjiAddressLine}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.kanaAddressLine")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength="100"
                      onChange={(e) => setKanaAddressLine(e.target.value)}
                      value={kanaAddressLine}
                    />
                    {orgErrors.kanaAddressLine && (
                      <p className="error-text">
                        {lang(`${orgErrors.kanaAddressLine}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.tel")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      onChange={(e) => setTelephone(e.target.value)}
                      maxLength="15"
                      value={telephone}
                    />
                    {orgErrors.telephone && (
                      <p className="error-text">
                        {lang(`${orgErrors.telephone}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.representativePersonCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="mrs-main">
                    <div className="mrs-box">
                      <label className="select-mrs">{representativeCode}</label>
                      <div>
                        {representativeCode && (
                          <button
                            className="cancel"
                            onClick={() => setRepresentativeCode("")}
                          >
                            X
                          </button>
                        )}
                        <button
                          className="btn btn-primary"
                          onClick={handleSelect}
                        >
                          {lang("Buttons.select")}
                        </button>
                      </div>
                    </div>
                    <div className={active}>
                      <div className="row">
                        <div className="col-md-9">
                          <div className="form-group inline-input lg">
                            <label>
                              {lang("organizationDetails.unifiedCustomerCode")}
                            </label>
                            <input
                              type="text"
                              maxLength="10"
                              className="form-control"
                              onChange={(e) =>
                                setUnifiedCustomerCode(e.target.value)
                              }
                              value={unifiedCustomerCode}
                            />
                          </div>
                          <div className="form-group inline-input lg">
                            <label>
                              {lang("organizationDetails.kanjiCustomerName")}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              maxLength="100"
                              value={kanjiCustomerName}
                              onChange={(e) =>
                                setKanjiCustomerName(e.target.value)
                              }
                            />
                            {representativeErrors.kanjiCustomerName && (
                              <p className="error-text">
                                {lang(
                                  `${representativeErrors.kanjiCustomerName}`
                                )}
                              </p>
                            )}
                          </div>
                          <div className="form-group inline-input lg">
                            <label>
                              {lang("organizationDetails.kanaCustomerName")}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              maxLength="100"
                              value={kanaCustomerName}
                              onChange={(e) =>
                                setKanaCustomerName(e.target.value)
                              }
                            />
                            {representativeErrors.kanaCustomerName && (
                              <p className="error-text">
                                {lang(
                                  `${representativeErrors.kanaCustomerName}`
                                )}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 mb-4">
                          <button
                            className="btn btn-primary"
                            onClick={getRepresentativeList}
                            disabled={orgRepresentativeLoading}
                          >
                            {lang("Buttons.apply")}
                          </button>
                        </div>
                      </div>

                      {!orgRepresentativeLoading &&
                        orgRepresentativeList.length > 0 && (
                          <>
                            <p className="record-total">
                              {lang(
                                "territoryDefinitionMaintenance.totalRecords"
                              )}{" "}
                              -{orgRepresentativeList.length} /{" "}
                              {orgRepresentativeTotal}
                            </p>
                            <div
                              ref={orgRef}
                              className="table-responsive esearch-table"
                            >
                              <table className="table" aria-describedby="table">
                                <thead>
                                  <tr>
                                    <th scope="col"></th>
                                    <th
                                      scope="col"
                                      onClick={() =>
                                        handleSortingData({
                                          /*                                        column: "legacyUnifiedCustomerCode",   /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                          column:
                                            "unifiedCustomerCode" /* SAKAMOTO: AHDD-5861 Ultmarc code change */,
                                          sortOrder:
                                            sortCode === "desc"
                                              ? "asc"
                                              : "desc",
                                        })
                                      }
                                    >
                                      <div className="cursor-pointer">
                                        {lang(
                                          "organizationDetails.unifiedCustomerCode"
                                        )}
                                        <em className="bx bxs-sort-alt"></em>
                                      </div>
                                    </th>
                                    <th
                                      scope="col"
                                      onClick={() =>
                                        handleSortingData({
                                          column: "customerNameLocal",
                                          sortOrder:
                                            sortKanjiName === "desc"
                                              ? "asc"
                                              : "desc",
                                        })
                                      }
                                    >
                                      <div className="cursor-pointer">
                                        {lang(
                                          "organizationDetails.kanjiCustomerName"
                                        )}
                                        <em className="bx bxs-sort-alt"></em>
                                      </div>
                                    </th>
                                    <th
                                      scope="col"
                                      onClick={() =>
                                        handleSortingData({
                                          column: "customerNameLocalKana",
                                          sortOrder:
                                            sortKanaName === "desc"
                                              ? "asc"
                                              : "desc",
                                        })
                                      }
                                    >
                                      <div className="cursor-pointer">
                                        {lang("OrganizationMenu.customerType")}
                                        <em className="bx bxs-sort-alt"></em>
                                      </div>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {orgRepresentativeList &&
                                    orgRepresentativeList.map((item, index) => {
                                      return (
                                        <tr key={`${item.orgCustID}-${index}`}>
                                          <td>
                                            <button
                                              className="btn btn-primary"
                                              onClick={() =>
                                                handleRepresentativeCode(item)
                                              }
                                            >
                                              {lang("Buttons.select")}
                                            </button>
                                          </td>
                                          <td>
                                            {/* item.legacyUnifiedCustomerCode /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                                            {
                                              item.unifiedCustomerCode /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                            }
                                          </td>
                                          <td>{item.customerNameLocal}</td>
                                          <td>{item.customerTypeNameLocal}</td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </div>
                          </>
                        )}
                      {orgRepresentativeLoading && (
                        <Spinner animation="border" />
                      )}
                      {noRepresentativeData && (
                        <div className="noData">
                          {lang("errorMessages.NO_DATA")}
                        </div>
                      )}
                      <div className="mt-2 text-right">
                        <button
                          className="btn btn-primary"
                          onClick={handleClose}
                        >
                          {lang("Buttons.close")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.kanjiRepresentativePerson")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength="40"
                      onChange={(e) =>
                        setKanjiRepresentativeName(e.target.value)
                      }
                      value={kanjiRepresentativeName}
                    />
                    {orgErrors.kanjiRepresentativeName && (
                      <p className="error-text">
                        {lang(`${orgErrors.kanjiRepresentativeName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.kanaRepresentativePerson")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength="20"
                      onChange={(e) =>
                        setKanaRepresentativeName(e.target.value)
                      }
                      value={kanaRepresentativeName}
                    />
                    {orgErrors.kanaRepresentativeName && (
                      <p className="error-text">
                        {lang(`${orgErrors.kanaRepresentativeName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.kanjiPharmacist")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength="40"
                      onChange={(e) => setKanjiPharmacistName(e.target.value)}
                      value={kanjiPharmacistName}
                    />
                    {orgErrors.kanjiPharmacistName && (
                      <p className="error-text">
                        {lang(`${orgErrors.kanjiPharmacistName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.kanaPharmacist")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength="20"
                      onChange={(e) => setKanaPharmacistName(e.target.value)}
                      value={kanaPharmacistName}
                    />
                    {orgErrors.kanaPharmacistName && (
                      <p className="error-text">
                        {lang(`${orgErrors.kanaPharmacistName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.numberOfBeds")}
                    {customerCode === "200" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength="4"
                      pattern="\[0-9]{4}\"
                      onChange={(e) => setNumberOfBeds(e.target.value)}
                      value={numberOfBeds}
                    />
                    {orgErrors.numberOfBeds && (
                      <p className="error-text">
                        {lang(`${orgErrors.numberOfBeds}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.plannedOpenDate")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <DatePicker
                      selected={openDateValue}
                      value={openDate}
                      className="form-control"
                      onChange={(date) => handleOpenDate(date)}
                      style={{ display: "block" }}
                      isClearable
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.specialities")}
                    {customerCode === "200" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      mode="multiple"
                      value={specialities}
                      options={specialityList}
                      onChange={handleSpeciality}
                      placeholder={lang("organizationDetails.specialities")}
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                    <p>Please select upto 60 specialities</p>
                    {customerCode === "200" && orgErrors.specialities && (
                      <p className="error-text">
                        {lang(`${orgErrors.specialities}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.remarks")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      onChange={(e) => setRemarks(e.target.value)}
                      maxLength="200"
                      value={remarks}
                    ></textarea>
                    {orgErrors.remarks && (
                      <p className="error-text">
                        {lang(`${orgErrors.remarks}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
    },
    {
      title: `${lang("organizationDetails.confirmationLabel")}`,
      content: (
        <React.Fragment>
          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.confirmationLabel")}</h4>
            </div>
            <div className="card-body">
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("customerRequestStatus.submissionType")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {lang("customerRequestStatus.new")}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("customerRequestStatus.submissionData")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {lang("customerRequestStatus.organizationCustomer")}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.submissionID")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label"></div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.unifiedCustomerCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label"></div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.customerType")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {customerTypeName ? customerTypeName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.kanjiFacilityName")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanjiFacilityName ? kanjiFacilityName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.kanaFacilityName")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanaFacilityName ? kanaFacilityName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.managementBody")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {managementName ? managementName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.postalCode")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {postalCode ? postalCode : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("parentChildFacilityMaintenance.prefecture")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {prefecture ? prefecture : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("parentChildFacilityMaintenance.city")}</label>
                  <span className="danger">*</span>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {city ? city : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.suburb")}</label>
                  <span className="danger">*</span>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {suburb ? suburb : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.street")}</label>
                  <span className="danger">*</span>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {street ? street : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.kanjiAddressLine")}</label>
                  <span className="danger">*</span>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanjiAddressLine ? kanjiAddressLine : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.kanaAddressLine")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanaAddressLine ? kanaAddressLine : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.tel")}</label>
                  <span className="danger">*</span>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {telephone ? telephone : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.representativePersonCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {representativeCode ? representativeCode : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.kanjiRepresentativePerson")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanjiRepresentativeName ? kanjiRepresentativeName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.kanaRepresentativePerson")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanaRepresentativeName ? kanaRepresentativeName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.kanjiPharmacist")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanjiPharmacistName ? kanjiPharmacistName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.kanaPharmacist")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanaPharmacistName ? kanaPharmacistName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.numberOfBeds")}</label>
                  {customerCode === "200" && <span className="danger">*</span>}
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {numberOfBeds ? numberOfBeds : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.plannedOpenDate")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">{openDate}</div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.specialities")}
                    {customerCode === "200" && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  {specialities &&
                    specialities.map((sp) => {
                      return (
                        <div key={sp.value} className="value-label color-dark">{sp.label}</div>
                      );
                    })}
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.remarks")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {remarks ? remarks : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
    },
    {
      title: `${lang("organizationDetails.completedLabel")}`,
      content: (
        <React.Fragment>
          <div className="submission-box card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.completedLabel")}</h4>
            </div>
            <div className="card-body">
              <p className="mb-3">
                {lang("errorMessages.REQUEST_SUBMITTED")}
                <span className="subm-title">
                  {lang("organizationDetails.submissionID")} :{" "}
                  {orgSubmissionId ? orgSubmissionId : ""}
                </span>
              </p>
              <p className="mb-3">
                {lang("errorMessages.VIEW_SUBMISSION_STATUS")}
                <a
                  className="link"
                  onClick={(e) => {
                    changeRoute(e, "/customerRequestStatus");
                  }}
                >
                  {" "}
                  {lang("Menu.customerRequestStatus")}
                </a>
              </p>
            </div>
          </div>
        </React.Fragment>
      ),
    },
  ];

  const personSteps = [
    {
      title: `${lang("organizationDetails.custNewChangeRequest")}`,
      content: (
        <React.Fragment>
          <div className="warning-box card">
            <div className="card-body">
              {/* <div className="warning-icon">
                <img src="images/warning.svg" alt="warning" />
              </div> */}
              {/* <h4>{lang("organizationDetails.noticeLabel")}</h4> */}
              <div
                className="notice"
                dangerouslySetInnerHTML={{ __html: personNotice }}
              />
            </div>
          </div>
          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.custNewChangeRequest")}</h4>
            </div>
            <div className="card-body">
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.submissionID")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input type="text" className="form-control" readOnly />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.unifiedCustomerCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      maxLength="10"
                      value=""
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.customerType")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={personCustomerTypeList}
                      onChange={handlePersonCustomerType}
                      allowClear={true}
                      placeholder={
                        customerTypeName
                          ? customerTypeName
                          : `${lang("organizationDetails.customerType")}`
                      }
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                    {personErrors.customerType && (
                      <p className="error-text">
                        {lang(`${personErrors.customerType}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("PersonMenu.kanjiName")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={kanjiFacilityName}
                      maxLength="100"
                      onChange={(e) => setKanjiFacilityName(e.target.value)}
                    />
                    {personErrors.kanjiFacilityName && (
                      <p className="error-text">
                        {lang(`${personErrors.kanjiFacilityName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.kanaName")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={kanaFacilityName}
                      maxLength="100"
                      onChange={(e) => setKanaFacilityName(e.target.value)}
                    />
                    {personErrors.kanaFacilityName && (
                      <p className="error-text">
                        {lang(`${personErrors.kanaFacilityName}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.gender")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={genderList}
                      onChange={handleGenderChange}
                      allowClear={true}
                      placeholder={
                        genderName ? genderName : `${lang("PersonMenu.gender")}`
                      }
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                  </div>
                </div>
              </div>
              {/* <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.birthPlace")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={prefectureList}
                      onChange={handleStateChange}
                      allowClear={true}
                      placeholder={
                        prefecture
                          ? prefecture
                          : `${lang("PersonMenu.birthPlace")}`
                      }
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                  </div>
                </div>
              </div> */}
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.birthDate")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <DatePicker
                      selected={birthDateValue}
                      value={birthDate}
                      peekNextMonth
                      showMonthDropdown
                      openToDate={calculateInitialDate(birthDateValue)}
                      showYearDropdown
                      // setDefaultDate={true}
                      dropdownMode="select"
                      className="form-control"
                      placeholderText={lang("PersonMenu.birthDate")}
                      onChange={(date) => handleBirthDate(date)}
                      // showYearPicker
                      dateFormat="mm/dd/yyyy"
                      // yearItemNumber={9}
                      isClearable
                    />
                    {personErrors.birthDate && (
                      <p className="error-text">
                        {lang(`${personErrors.birthDate}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.dentistAssociation")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={prefectureList}
                      onChange={handleAssociation}
                      allowClear={true}
                      placeholder={
                        associationName
                          ? associationName
                          : `${lang("PersonMenu.dentistAssociation")}`
                      }
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.graduatedUniversity")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={universityList}
                      onChange={handleUniversity}
                      allowClear={true}
                      placeholder={
                        universityName
                          ? universityName
                          : `${lang("PersonMenu.graduatedUniversity")}`
                      }
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                    {personErrors.graduatedUniversity && (
                      <p className="error-text">
                        {lang(`${personErrors.graduatedUniversity}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.graduatedYear")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <DatePicker
                      selected={graduatedYearValue}
                      value={graduatedYear}
                      className="form-control"
                      placeholderText={lang("PersonMenu.graduatedYear")}
                      onChange={(date) => handleGraduatedYear(date)}
                      showYearPicker
                      dateFormat="yyyy"
                      yearItemNumber={9}
                      isClearable
                    />
                    {personErrors.graduatedYear && (
                      <p className="error-text">
                        {lang(`${personErrors.graduatedYear}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("PersonMenu.registeredYear")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <DatePicker
                      className="form-control"
                      selected={registeredYearValue}
                      value={registeredYear}
                      placeholderText={lang("PersonMenu.registeredYear")}
                      onChange={(date) => handleRegisteredYear(date)}
                      showYearPicker
                      dateFormat="yyyy"
                      yearItemNumber={9}
                      isClearable
                    />
                    {personErrors.registeredYear && (
                      <p className="error-text">
                        {lang(`${personErrors.registeredYear}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.specialities")}
                    {customerCode === "100" &&
                     roleName !== RESIDENT_DOCTOR_ROLE &&
                     universityRoleName !== RESIDENT_DOCTOR_ROLE && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      mode="multiple"
                      value={specialities}
                      options={specialityList}
                      onChange={handlePersonSpeciality}
                      placeholder={lang("organizationDetails.specialities")}
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                    <p>Please select upto 5 specialities</p>
                    {customerCode === "100" && personErrors.specialities && (
                      <p className="error-text">
                        {lang(`${personErrors.specialities}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.affiliatedName")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <div className="mrs-main">
                      <div className="mrs-box">
                        <label className="select-mrs">
                          {representativeName}
                        </label>
                        <div>
                          {representativeCode && (
                            <button
                              className="cancel"
                              onClick={() => {
                                setRepresentativeName("");
                                setRepresentativeCode("");
                                setcheckState(false);
                              }}
                            >
                              X
                            </button>
                          )}
                          <button
                            className="btn btn-primary"
                            onClick={handleSelect}
                          >
                            {lang("Buttons.select")}
                          </button>
                        </div>
                      </div>
                      <div className={active}>
                        <div className="row">
                          <div className="col-md-9">
                            <div className="form-group inline-input lg">
                              <label>
                                {lang(
                                  "organizationDetails.unifiedCustomerCode"
                                )}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={unifiedCustomerCode}
                                onChange={(e) =>
                                  setUnifiedCustomerCode(e.target.value)
                                }
                              />
                            </div>
                            <div className="form-group inline-input lg">
                              <label>
                                {lang("organizationDetails.kanjiCustomerName")}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={kanjiCustomerName}
                                onChange={(e) =>
                                  setKanjiCustomerName(e.target.value)
                                }
                              />
                              {customerErrors.kanjiCustomerName && (
                                <p className="error-text">
                                  {lang(`${customerErrors.kanjiCustomerName}`)}
                                </p>
                              )}
                            </div>
                            <div className="form-group inline-input lg">
                              <label>
                                {lang("organizationDetails.kanaCustomerName")}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                value={kanaCustomerName}
                                onChange={(e) =>
                                  setKanaCustomerName(e.target.value)
                                }
                              />
                              {customerErrors.kanaCustomerName && (
                                <p className="error-text">
                                  {lang(`${customerErrors.kanaCustomerName}`)}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-12 mb-4">
                            <button
                              className="btn btn-primary"
                              onClick={getOrgRepresentativeList}
                              disabled={personRepresentativeLoading}
                            >
                              {lang("Buttons.apply")}
                            </button>
                          </div>
                        </div>
                        {!personRepresentativeLoading &&
                          representativeList.length > 0 && (
                            <>
                              <p className="record-total">
                                {lang(
                                  "territoryDefinitionMaintenance.totalRecords"
                                )}{" "}
                                - {representativeList.length} /{" "}
                                {representativeTotal}
                              </p>
                              <div
                                ref={personRef}
                                className="table-responsive esearch-table"
                              >
                                <table
                                  className="table"
                                  aria-describedby="table"
                                >
                                  <thead>
                                    <tr>
                                      <th scope="col"></th>
                                      <th
                                        scope="col"
                                        onClick={() =>
                                          handlePersonSortingData({
                                            column: "unifiedCustomerCode",
                                            sortOrder:
                                              sortCode === "desc"
                                                ? "asc"
                                                : "desc",
                                          })
                                        }
                                      >
                                        <div className="cursor-pointer">
                                          {lang(
                                            "organizationDetails.unifiedCustomerCode"
                                          )}
                                          <em className="bx bxs-sort-alt"></em>
                                        </div>
                                      </th>
                                      <th
                                        scope="col"
                                        onClick={() =>
                                          handlePersonSortingData({
                                            column: "facilityName",
                                            sortOrder:
                                              sortKanjiName === "desc"
                                                ? "asc"
                                                : "desc",
                                          })
                                        }
                                      >
                                        <div className="cursor-pointer">
                                          {lang(
                                            "organizationDetails.kanjiCustomerName"
                                          )}
                                          <em className="bx bxs-sort-alt"></em>
                                        </div>
                                      </th>
                                      <th
                                        scope="col"
                                        onClick={() =>
                                          handlePersonSortingData({
                                            column: "customerTypeName",
                                            sortOrder:
                                              sortKanaName === "desc"
                                                ? "asc"
                                                : "desc",
                                          })
                                        }
                                      >
                                        <div className="cursor-pointer">
                                          {lang(
                                            "OrganizationMenu.customerType"
                                          )}
                                          <em className="bx bxs-sort-alt"></em>
                                        </div>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {representativeList &&
                                      representativeList.map((item, index) => {
                                        return (
                                          <tr key={`${item.orgCustID}-${index}`}>
                                            <td>
                                              <button
                                                className="btn btn-primary"
                                                onClick={() =>
                                                  handleAffiliatedCode(item)
                                                }
                                              >
                                                {lang("Buttons.select")}
                                              </button>
                                            </td>
                                            <td>
                                              {/* item.legacyUnifiedCustomerCode /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                                              {
                                                item.unifiedCustomerCode /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                              }
                                            </td>
                                            <td>{item.facilityName}</td>
                                            <td>{item.customerTypeName}</td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                </table>
                              </div>
                            </>
                          )}
                        {personRepresentativeLoading && (
                          <Spinner animation="border" />
                        )}
                        {noData && (
                          <div className="noData">
                            {lang("errorMessages.NO_DATA")}
                          </div>
                        )}
                        <div className="mt-2 text-right">
                          <button
                            className="btn btn-primary"
                            onClick={handleClose}
                          >
                            {lang("Buttons.close")}
                          </button>
                        </div>
                      </div>

                      {personErrors.representativeCode && (
                        <p className="error-text">
                          {lang(`${personErrors.representativeCode}`)}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.affiliatedDepartment")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={departmentList}
                      onChange={handleDepartment}
                      allowClear={true}
                      placeholder={
                        departmentName
                          ? departmentName
                          : `${lang(
                              "organizationDetails.affiliatedDepartment"
                            )}`
                      }
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.role")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      allowClear={true}
                      options={roleList}
                      onChange={handleRole}
                      placeholder={
                        roleName
                          ? roleName
                          : `${lang("organizationDetails.role")}`
                      }
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.universityRole")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <Select
                      className="ant-select"
                      options={roleList}
                      onChange={handleUniversityRole}
                      allowClear={true}
                      placeholder={
                        universityRoleName
                          ? universityRoleName
                          : `${lang("organizationDetails.universityRole")}`
                      }
                      labelInValue={true}
                      showSearch
                      optionFilterProp="label"
                    />
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield mt-2">
                <div className="custom-3">
                  <label>{lang("organizationDetails.hospitalOwner")}</label>
                </div>
                <div className="custom-9">
                  <div className="custom-checkbox mb-0">
                    <input
                      type="checkbox"
                      id="owner2"
                      name="table-checkbox"
                      checked={hospitalStatus}
                      onChange={(e) => handleHospitalStatus(e)}
                    />
                    <label className="mb-0" htmlFor="owner2"></label>
                  </div>
                </div>
              </div>
              {customerCode === "120" && (
                <div className="horizon-form with-textfield mt-2">
                  <div className="custom-3">
                    <label>{lang("PersonMenu.ultmarcPharmacistFlag")}</label>
                  </div>
                  <div className="custom-9">
                    <div className="custom-checkbox mb-0">
                      <input
                        type="checkbox"
                        id="pharmacistFlag"
                        name="table-checkbox"
                        disabled
                        // checked={isUltmarcPharmacist}
                        checked={ultraMacFlagValue}
                        onChange={(e) => handleUltmarcPharmacistFlag(e)}
                      />
                      <label className="mb-0" htmlFor="pharmacistFlag"></label>
                    </div>
                  </div>
                </div>
              )}
              <div className="horizon-form">
                <div className="custom-3">
                  <label>{lang("organizationDetails.remarks")}</label>
                </div>
                <div className="custom-9">
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      value={remarks}
                      maxLength="200"
                      onChange={(e) => setRemarks(e.target.value)}
                    ></textarea>
                    {personErrors.remarks && (
                      <p className="error-text">
                        {lang(`${personErrors.remarks}`)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
    },
    {
      title: `${lang("organizationDetails.confirmationLabel")}`,
      content: (
        <React.Fragment>
          <div className="card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.confirmationLabel")}</h4>
            </div>
            <div className="card-body">
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("customerRequestStatus.submissionType")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {lang("customerRequestStatus.new")}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("customerRequestStatus.submissionData")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {lang("customerRequestStatus.personCustomer")}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.submissionID")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label"></div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.unifiedCustomerCode")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark"></div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.customerType")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {customerTypeName ? customerTypeName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.kanjiFacilityName")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanjiFacilityName ? kanjiFacilityName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("OrganizationMenu.kanaFacilityName")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {kanaFacilityName ? kanaFacilityName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("PersonMenu.gender")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {genderName ? genderName : ""}
                  </div>
                </div>
              </div>
              {/* <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("PersonMenu.birthPlace")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {prefecture ? prefecture : ""}
                  </div>
                </div>
              </div> */}
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("PersonMenu.dentistAssociation")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {associationName}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("PersonMenu.graduatedUniversity")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {universityName ? universityName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("PersonMenu.graduatedYear")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {graduatedYear ? graduatedYear : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("PersonMenu.registeredYear")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {registeredYear ? registeredYear : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.specialities")}
                    {customerCode === "100" &&
                     roleName !== RESIDENT_DOCTOR_ROLE &&
                     universityRoleName !== RESIDENT_DOCTOR_ROLE && (
                      <span className="danger">*</span>
                    )}
                  </label>
                </div>
                <div className="custom-9">
                  {specialities &&
                    specialities.map((sp) => {
                      return (
                        <div key={sp.value} className="value-label color-dark">{sp.label}</div>
                      );
                    })}
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("OrganizationMenu.affiliatedName")}
                    <span className="danger">*</span>
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {representativeName
                      ? representativeName + "(" + representativeCode + ")"
                      : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>
                    {lang("organizationDetails.affiliatedDepartment")}
                  </label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {departmentName ? departmentName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.role")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {roleName ? roleName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.universityRole")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">
                    {universityRoleName ? universityRoleName : ""}
                  </div>
                </div>
              </div>
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.hospitalOwner")}</label>
                </div>
                <div className="custom-9">
                  <div className="custom-checkbox">
                    <input
                      type="checkbox"
                      id="check1"
                      name="table-checkbox"
                      value={hospitalStatus}
                      checked={hospitalStatus}
                      disabled
                    />
                    <label className="mb-0" htmlFor="check1"></label>
                  </div>
                </div>
              </div>
              {customerCode == "120" && (
                <div className="horizon-form with-textfield">
                  <div className="custom-3">
                    <label>{lang("PersonMenu.ultmarcPharmacistFlag")}</label>
                  </div>
                  <div className="custom-9">
                    <div className="custom-checkbox">
                      <input
                        type="checkbox"
                        id="check2"
                        name="table-checkbox"
                        // value={isUltmarcPharmacist}
                        checked={ultraMacFlagValue}
                        // checked={isUltmarcPharmacist}
                        disabled
                      />
                      <label className="mb-0" htmlFor="check2"></label>
                    </div>
                  </div>
                </div>
              )}
              <div className="horizon-form with-textfield">
                <div className="custom-3">
                  <label>{lang("organizationDetails.remarks")}</label>
                </div>
                <div className="custom-9">
                  <div className="value-label color-dark">{remarks}</div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
    },
    {
      title: `${lang("organizationDetails.completedLabel")}`,
      content: (
        <React.Fragment>
          <div className="submission-box card shadow-card">
            <div className="card-header">
              <h4>{lang("organizationDetails.completedLabel")}</h4>
            </div>
            <div className="card-body">
              <p className="mb-3">
                {lang("errorMessages.REQUEST_SUBMITTED")}
                <span className="subm-title">
                  {lang("organizationDetails.submissionID")} :{" "}
                  {personSubmissionId ? personSubmissionId : ""}
                </span>
              </p>
              <p className="mb-3">
                {lang("errorMessages.VIEW_SUBMISSION_STATUS")}
                <a
                  className="link"
                  onClick={(e) => {
                    changeRoute(e, "/customerRequestStatus");
                  }}
                >
                  {" "}
                  {lang("Menu.customerRequestStatus")}
                </a>
              </p>
            </div>
          </div>
        </React.Fragment>
      ),
    },
  ];

  return (
    <Home>
      {maintenance ? (
        <Maintenance />
      ) : (
        <>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a
                  onClick={(e) => {
                    changeRoute(e, "/");
                  }}
                >
                  {lang("Menu.home")}
                </a>
              </li>
              <li className="breadcrumb-item">
                <a onClick={goToHome}>{lang("Menu.newCustomerRequest")}</a>
              </li>
              {organizationRequest && (
                <li className="breadcrumb-item" aria-current="page">
                  {lang("organizationDetails.orgCustomerChangeRequest")}
                </li>
              )}
              {personRequest && (
                <li className="breadcrumb-item" aria-current="page">
                  {lang("personDetails.personCustomerChangeRequest")}
                </li>
              )}
            </ol>
          </nav>
          {finalText && <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <div>
                  <div style={{marginBottom : '4px'}} dangerouslySetInnerHTML={{ __html: finalText2 }} className="notice"></div>
                  <div dangerouslySetInnerHTML={{ __html: finalText }} className="notice"></div>
                </div>
              </li>
            </ol>
          </nav>}
          <Accordion defaultActiveKey={eventKey} className="shadow-accordion">
            <Accordion.Item eventKey={eventKey}>
              <Accordion.Header>
                {lang("organizationDetails.custNewChangeRequest")}
              </Accordion.Header>
              <Accordion.Body>
                <div className="sb-row justify-start">
                  <div className="sb-label">
                    {lang("customerRequestStatus.submissionType")}
                  </div>
                  <div className="sb-content-auto">
                    <a href="#">{lang("customerRequestStatus.new")}</a>
                  </div>
                </div>
                <div className="sb-row flex-start justify-start">
                  <div className="sb-label">
                    {lang("customerRequestStatus.submissionData")}
                  </div>
                  <div className="sb-content-auto">
                    <div className="switch-field">
                      <div className="switch-inner">
                        <input
                          type="radio"
                          id="switch_left"
                          name="switch_2"
                          value="Organization Customer"
                          onChange={(e) => handleRequest(e)}
                          defaultChecked
                        />
                        <label htmlFor="switch_left">
                          {lang("customerRequestStatus.organizationCustomer")}
                        </label>
                        <input
                          type="radio"
                          id="switch_right"
                          name="switch_2"
                          value="Person Customer"
                          onChange={(e) => handleRequest(e)}
                        />
                        <label htmlFor="switch_right">
                          {lang("customerRequestStatus.personCustomer")}
                        </label>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary"
                      onClick={handleSubmit}
                    >
                      {lang("Buttons.apply")}
                    </button>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          {organizationRequest && (
            <>
              <Steps current={current}>
                {organizationSteps.map((item) => (
                  <Step key={item.title} title={item.title} />
                ))}
              </Steps>
              <div className="steps-content horizon-form-lg">
                {organizationSteps[current].content}
              </div>
              <div className="steps-action">
                {orgLoading && <Spinner animation="border" />}
                {current > 0 && current < 2 && (
                  <Button
                    style={{ margin: "0 12px" }}
                    onClick={() => prev()}
                    disabled={orgLoading}
                  >
                    {lang("Buttons.previous")}
                  </Button>
                )}
                {current < 2 && (
                  <Button
                    type="primary"
                    onClick={() => (current < 1 ? next() : addOrgCustomer())}
                    disabled={orgLoading}
                  >
                    {current < 1
                      ? `${lang("Buttons.next")}`
                      : `${lang("Buttons.submit")}`}
                  </Button>
                )}
              </div>
            </>
          )}

          {personRequest && (
            <>
              <Steps current={current}>
                {personSteps.map((item) => (
                  <Step key={item.title} title={item.title} />
                ))}
              </Steps>
              <div className="steps-content horizon-form-lg">
                {personSteps[current].content}
              </div>
              <div className="steps-action">
                {personLoading && <Spinner animation="border" />}
                {current > 0 && current < 2 && (
                  <Button
                    style={{ margin: "0 12px" }}
                    onClick={() => prev()}
                    disabled={personLoading}
                  >
                    {lang("Buttons.previous")}
                  </Button>
                )}
                {current < 2 && (
                  <Button
                    type="primary"
                    onClick={() => (current < 1 ? next() : addPerCustomer())}
                    disabled={personLoading}
                  >
                    {current < 1
                      ? `${lang("Buttons.next")}`
                      : `${lang("Buttons.submit")}`}
                  </Button>
                )}
              </div>
            </>
          )}
          <Modal
            size="md"
            className="withdraw-modal"
            show={showMessage}
            onHide={handleCloseMessage}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                {lang("errorMessages.REQUEST_NOT_SUBMITTED")}
              </div>
              <div className="buttons-group">
                <button
                  className="btn btn-primary"
                  onClick={handleCloseMessage}
                >
                  {lang("Buttons.ok")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </Home>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.organizationCustomer.language,
  };
};

export default connect(mapStateToProps, { fetchClassificationsList })(
  NewCustomerRequest
);
